import { CompleteRegistrationFlowStepKey } from './CompleteRegistrationFlow'

export const GETTING_STARTED_STEP_TITLES: Record<
  CompleteRegistrationFlowStepKey,
  string
> = {
  companyServices: 'What services does your firm offer?',
  connectEmailAndCalendar: 'Connect your email and calendar to RQ',
  companyExpertiseAreas: "What are your firm's areas of expertise?",
  companyOfficeLocations: "Where are your firm's office locations?",
  inviteReferralPartners: 'Invite your referral partners to RQ',
  importHistoricalReferrals: 'Upload your existing referrals data',
  meetingLink: 'Your meeting links',
  uploadLogo: "Upload your firm's logo",
  uploadVideo: 'Share a video about you or your firm',
}

export const GETTING_STARTED_STEP_NAMES: Record<
  CompleteRegistrationFlowStepKey,
  string
> = {
  companyServices: 'List your services',
  connectEmailAndCalendar: 'Connect your email and calendar to RQ',
  companyExpertiseAreas: 'Select your areas of expertise',
  companyOfficeLocations: 'Enter your office locations',
  inviteReferralPartners: 'Invite your referral partners to RQ',
  importHistoricalReferrals: 'Upload your existing referrals data',
  meetingLink: 'Provide your meeting links',
  uploadLogo: "Upload your firm's logo",
  uploadVideo: 'Upload video about your firm',
}
